module.exports = __webpack_public_path__ + "img/ar_to_ardrive.96e02ccb.png";